import { render, staticRenderFns } from "./survey-costbreakdown.vue?vue&type=template&id=16bd054d"
import script from "./survey-costbreakdown.vue?vue&type=script&lang=js"
export * from "./survey-costbreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports